<template>

  <div class="panel">

    <b-field horizontal>
      <a v-bind:href="downloadTemplate()" download="template-csv">
        <b-button class="button-secondary">
           Descargar Plantilla
        </b-button>
      </a>
    </b-field>

  </div>

</template>

<script>
import TemplateRepository from '@/services/TemplateRepository'
export default {
  name: 'DownloadCSV',
  methods: {
    downloadTemplate () {
      return TemplateRepository.urlDownloadTemplate()
    }
  }
}
</script>
